import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  Button,
} from "@mui/material";
import { useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../../theme";
import Header from "../../Dashboard/Header";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
const PREFERENCE_KEY = "infiniteAppUserPreferences";

export default function LedGroup() {
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [pageSize, setPageSize] = useState(20);
  const [GroupData, setGroupData] = useState([]);

  const token = localStorage.getItem("token");
  const cmpid = localStorage.getItem("cmpid");

  // Load saved user preferences from localStorage
  const saved = localStorage.getItem(PREFERENCE_KEY);
  const preferences = saved
    ? JSON.parse(saved)
    : {
        rowHeight: 40,
        fontFamily: "Source Sans Pro",
        fontSize: 16,
        tableAlign: "center",
      };

  /* ───────── fetch Group ───────── */

  const fetchGroupList = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/display/group`,
        { cmpid },
        { headers: { Authorization: token } }
      );
      const GroupList = response.data.groupMap[0].group;
      setGroupData(GroupList);
      //  console.log("data : ", GroupList);
    } catch (err) {
      console.log("Error fetching group data", err);
    }
  };

  useEffect(() => {
    fetchGroupList();
  }, []);

  const handleRowClick = (params) => {
    const group = params.row;
    navigate(`/Infinite/GroupDetails/${group.id}`);
  };

  // ==============================================

  const [searchQuery, setSearchQuery] = useState("");

  // Filter the users based on search query
  const filteredUsers = GroupData.filter((Grp) => {
    const searchLower = searchQuery.toLowerCase();
    return (
      Grp.groupName.toLowerCase().includes(searchLower) ||
      Grp.groupParent.toLowerCase().includes(searchLower)
    );
  });

  const GrpListData = filteredUsers.map((grp) => ({
    id: grp.groupId,
    groupName: grp.groupName,
    groupParent: grp.groupParent,
  }));

  // Export data function with the exact format from your CSV
  const handleExportData = () => {
    // Sample stock data matching your CSV format
    const stockData = [
      {
        date: "15-01-24",
        partyName: "Karan Indus",
        items: [
          { particular: "Laptop", qty: 5, rate: 1200 },
          { particular: "Mouse", qty: 20, rate: 25 },
          { particular: "Keyboard", qty: 15, rate: 45 }
        ]
      },
      {
        date: "16-01-24",
        partyName: "abc traders", 
        items: [
          { particular: "Laptop", qty: 5, rate: 1200 },
          { particular: "Mouse", qty: 20, rate: 25 },
          { particular: "Keyboard", qty: 15, rate: 45 }
        ]
      }
    ];  

    // Create CSV content with the exact format from your file
    const headers = ["Date", "Particular", "", "Qty", "Rate"];
    const csvRows = [headers.join(",")];

    stockData.forEach(day => {
      // First row: Date, Party Name, empty, total quantity, total rate
      const totalQty = day.items.reduce((sum, item) => sum + item.qty, 0);
      const totalRate = day.items.reduce((sum, item) => sum + (item.qty * item.rate), 0);
      
      const partyRow = [
        `"${day.date}"`,
        `"${day.partyName}"`,
        "",
        totalQty,
        totalRate
      ];
      csvRows.push(partyRow.join(","));

      // Subsequent rows: empty date, item particulars, empty, quantity, rate
      day.items.forEach((item) => {
        const itemRow = [
          "",
          `"${item.particular}"`,
          "",
          item.qty,
          item.rate
        ];
        csvRows.push(itemRow.join(","));
      });
    });

    // Add empty rows to match your CSV format
    for (let i = 0; i < 12; i++) {
      csvRows.push(",,,,");
    }

    const csvContent = csvRows.join("\n");

    // Create blob and download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "stock_data.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const columns = [
    {
      field: "id",
      headerName: "Sr No",
      flex: 1,
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      renderCell: (params) => params.api.getRowIndex(params.id) + 1,
    },
    {
      field: "groupName",
      headerName: "Group Name",
      flex: 1,
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
    },
    {
      field: "groupParent",
      headerName: "parent",
      flex: 1,
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
    },
  ];

  return (
    <>
      <Box mt="60px" ml="0px" mr="10px">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Header title="Group" subtitle="All Ledger group List" />
          <Box display="flex" alignItems="center" gap={2}>
            {/* Export Data Button */}
            <Button
              variant="contained"
              onClick={handleExportData}
              sx={{
                backgroundColor: colors.blueAccent[700],
                color: colors.primary[100],
                "&:hover": {
                  backgroundColor: colors.blueAccent[600],
                },
                height: "35px",
                minWidth: "120px",
                textTransform: "none",
                fontWeight: "bold",
              }}
            >
              Export Data
            </Button>
            
            <Box mt={1}>
              {/* Search Bar */}
              <TextField
                label="Search"
                variant="outlined"
                size="small"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "35px",
                    padding: "0 8px",
                    "& fieldset": {
                      borderColor: colors.primary[120],
                    },
                    "&:hover fieldset": {
                      borderColor: colors.primary[100],
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: colors.primary[80],
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: colors.primary[120],
                    lineHeight: "20px",
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: colors.primary[80],
                  },
                  color: colors.primary[120],
                }}
                InputLabelProps={{
                  style: { color: colors.primary[100] },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton edge="end" sx={{ color: colors.primary[120] }}>
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Typography
                variant="body2"
                sx={{ fontStyle: "italic", color: "gray", mr: 1 }}
              >
                Note: Please click any row Ledger Group for Settings.
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box
          height="80vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
              cursor: "pointer",
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[700],
              borderBottom: "none",
              color: colors.primary[120],
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[700],
              color: colors.primary[150],
            },
            "& .Grpzoom-row:hover": {
              transform: "scale(1.01)",
              transition: "transform 0.2s ease-in-out",
              zIndex: 1,
              backgroundColor: colors.blueAccent[900],
            },
          }}
        >
          <DataGrid
            rows={GrpListData}
            columns={columns}
            getRowId={(row) => row.id}
            onRowClick={handleRowClick}
            getRowClassName={() => "Grpzoom-row"}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            rowHeight={40}
            headerHeight={45}
            density="compact"
            sx={{
              "& .MuiDataGrid-cell": {
                padding: "0px 8px",
                lineHeight: "25px",
                fontSize: "14px",
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: colors.blueAccent[700],
                margin: "0 !important",
                padding: "0 !important",
              },
              "& .MuiDataGrid-columnHeader": {
                padding: "2px 8px !important",
                margin: "0 !important",
                height: "40px !important",
                minHeight: "40px !important",
                maxHeight: "40px !important",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontSize: "14px",
                fontWeight: "bold",
                whiteSpace: "normal !important",
                lineHeight: "1.2 !important",
                textAlign: "center",
              },
            }}
            componentsProps={{
              footer: {
                sx: {
                  height: 25, // Added footer height
                  minHeight: 25,
                },
              },
            }}
          />{" "}
        </Box>
      </Box>
    </>
  );
}